<template>
  <div class="extra-info">
    <span class="info-tag" v-if="lead.mobile" @click="doCopy('mobile', lead.mobile)">
      <i class="iconfont">&#xe613;</i>
      复制并保存手机
    </span>

    <span class="info-tag" v-if="lead.weixin" @click="doCopy('weixin', lead.weixin)">
      <i class="iconfont">&#xe600;</i>

      复制并保存微信
    </span>

    <span class="info-tag" v-if="lead.qq" @click="doCopy('qq', lead.qq)">
      <i class="iconfont">&#xe882;</i>

      复制并保存QQ
    </span>

    <span class="info-tag" v-if="lead.mobile" @click="doCheckMobile(message)">
      <i class="iconfont">&#xe8ef;</i>

      空号检测
    </span>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { setLeadInfo, getLeadInfo, checkMobile } from "@/api/common";
import { Toast } from "vant";
import { switchMap } from "rxjs/operators";

export default defineComponent({
  props: {
    message: Object,
  },

  components: {},

  computed: {
    // 为 message.ext?.match_fields 创建别名
    lead() {
      return this.message?.ext?.match_fields || {};
    },

    mobile_encrypt() {
      return this.message.ext?.match_fields_aes?.mobile_encrypt || undefined;
    },

    weixin_encrypt() {
      return this.message.ext?.match_fields_aes?.weixin_encrypt || undefined;
    },

    qq_encrypt() {
      return this.message.ext?.match_fields_aes?.qq_encrypt || undefined;
    }
  },

  methods: {
    doCopy(platform, content) {
      this.$copyText(content, undefined, () => { });

      const uid = this.message.uid;
      if (!uid) return;

      getLeadInfo(uid)
        .pipe(switchMap((res) => {
          const name = res.name || res.nickname;

          return setLeadInfo( {
            uid,
            name,
            gender: res.gender,
            mobile: res.mobile,
            mobile_encrypt: res.mobile_encrypt || undefined,
            weixin: res.weixin,
            weixin_encrypt: res.weixin_encrypt || undefined,
            qq: res.qq,
            qq_encrypt: res.qq_encrypt || undefined,
            [platform]: content,
            [platform + '_encrypt']: this[platform + '_encrypt'],
          });
        }))
        .subscribe(() => {
          Toast.success("保存成功");
        }, (err) => {
          console.log(err);
          Toast.fail(err.error.message);
        });
    },

    doCheckMobile(message) {
      checkMobile({
        mobile: this.lead.mobile,
        uid: message.uid,
        platform: message.platform,
        mobile_encrypt: this.mobile_encrypt,
      }).subscribe(() => {
        Toast.success("检测成功，请在消息流中查看");
      }, (err) => {
        if (err?.response?.data?.message) {
          Toast.fail(err.response.data.message);
        }
      })
    }
  },
});
</script>

<style lang="less" scoped>
.extra-info {
  &:before {
    clear: both;
    content: " ";
    display: block;
  }

  margin: 3px 0;
  font-size: 12px;

  .info-tag {
    border-radius: 8px;
    // background-color: white;
    border: 1px solid #2593f4;
    display: inline-block;
    padding: 5px;
    color: #2593f4;
    margin-top: 5px;
    cursor: pointer;
    margin-right: 5px;
  }

}

i.iconfont {
  font-size: 12px;
}
</style>
